import { Container, Title } from '@/components'
import Image from 'next/image'

import { PARTNERS } from './constants'
import styles from './styles.module.scss'

const Partners = () => {
  return (
    <section className={`fgt-section ${styles.partners}`}>
      <Container classname={styles.container}>
        <Title Tag="h2" alignText="center" colorText="pink">
          marcas parceiras da <span>academia foguete</span>
        </Title>

        <div className={styles.logos}>
          {PARTNERS &&
            PARTNERS.map(({ url, title, width, height, className }) => {
              return (
                <Image
                  key={title}
                  src={url}
                  alt={title}
                  width={width}
                  height={height}
                  className={`${styles[className]}`}
                />
              )
            })}
        </div>
      </Container>
    </section>
  )
}

export default Partners
